/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../components/ui-elements/loader';
import OrgAppsDevices from '../views/organization/application/devices/OrgAppsDevices';
import OrgAppDeviceCreationBtn from '../views/organization/application/devices/OrgAppDeviceCreationBtn';
import { useCallback } from 'react';
import { getAllOrgApplicationDevices } from '../../../../../store/reducers/organization/orgApplicationDevices/orgApplicationDevicesAction';
const ManageOrgApplicationsDevicesPage = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const fetchORgAppDevices = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllOrgApplicationDevices()).unwrap()
            setLoading(false)

        } catch (error) {
            setLoading(false)
        }
    }, [dispatch])
    useEffect(() => {
        fetchORgAppDevices()
    }, [fetchORgAppDevices]);
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations Applications Devices'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgAppDeviceCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgAppsDevices /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}

export default ManageOrgApplicationsDevicesPage; 